import { Link, useNavigate } from 'react-router-dom';
import { createUserWithEmailAndPassword, signInWithPopup } from "firebase/auth";
import { auth, provider } from '../firebase/config.js';
import { useContext, useEffect, useState } from 'react';
import UserContext from '../context/UserContext.js';
import { Toaster, toast } from '../components/Toast.jsx';
import AuthLayout from '../components/landing/AuthLayout.jsx';
import GoogleButton from '../components/landing/GoogleButton.jsx';
import { FREE_PRODUCT_LIMIT } from '../plans.js';


const Register = () => {

  const navigate = useNavigate();
  const LSuser = JSON.parse(window.localStorage.getItem("usuario"));

  const regex = /^[a-zA-Z0-9#\$@Ññ.\*\-]{6,20}$/;

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const {setUser} = useContext(UserContext);

  const signal = (message) => toast.success(message);
  const signalError = (message) => toast.error(message);

  const handleGoogle = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      setUser(result.user);
      window.localStorage.setItem("usuario", JSON.stringify(result.user));
      navigate("/cuenta");
    } catch (error) {
      console.error(error);
      if (error.code === "auth/unauthorized-domain") {
        signalError("Este dominio no está habilitado para entrar con Google.")
      } else if (error.code === "auth/popup-blocked") {
        signalError("El navegador bloqueó la ventana de Google. Permití las ventanas emergentes y probá de nuevo.")
      } else if (error.code !== "auth/popup-closed-by-user" && error.code !== "auth/cancelled-popup-request") {
        signalError("No pudimos registrarte con Google. Probá de nuevo.");
      }
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();


    if (password === confirmPassword) {

      if (!regex.test(password)) {
        signalError("Contraseña con caracteres no permitidos. Caracteres especiales permitidos: # $ @ Ñ ñ . * -")
        
      } else {
        createUserWithEmailAndPassword(auth, email, password)
        .then((userCredential) => {
          const user = userCredential.user;
          if (user) {
            navigate("/login");

            setTimeout(() => {
              
              signal("Registrado exitosamente. Inicie sesión.");
            }, 1000);
          }
        })
        .catch((error) => {
          const errorCode = error.code;
            
          if (errorCode === "auth/email-already-in-use") {
            signalError("El email ingresado ya se encuentra registrado.");
          } else if (errorCode === "auth/weak-password") {
            signalError("Contraseña muy débil. Debe tener al menos 6 caracteres.")
  
          }
        });
      }
    }
     else {
      signalError("Las contraseñas no coinciden.");
    }

  }

    useEffect(() => {
      if (LSuser) {
        navigate("/cuenta")
      }
    }, [LSuser])

  return (
    <AuthLayout
      title="Crear cuenta gratis - MiQRapp"
      description={`Creá gratis tu menú o catálogo online con QR. Cargá hasta ${FREE_PRODUCT_LIMIT} productos sin tarjeta y compartilo con tus clientes.`}
      path="/register"
      eyebrow="Gratis para siempre"
      heading="Creá tu catálogo en minutos"
      subheading={`Registrate gratis y cargá hasta ${FREE_PRODUCT_LIMIT} productos. Cuando quieras más, te pasás a Pro.`}
    >
      <h2>Creá tu cuenta</h2>

      <GoogleButton onClick={handleGoogle}>Registrarme con Google</GoogleButton>

      <div className="lp-auth-divider"><span>o con tu email</span></div>

      <form onSubmit={handleSubmit} className='lp-auth-form'>
        <div className="lp-field">
          <label htmlFor="register-email">Email</label>
          <input type="email" id="register-email" name="register-email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)}/>
        </div>

        <div className="lp-field">
          <label htmlFor="register-password">Contraseña</label>
          <input type="password" id="register-password" minLength={6} maxLength={20} name="register-password" autoComplete="new-password" value={password} required onChange={(e) => setPassword(e.target.value)}/>
          <span className="lp-field-hint">De 6 a 20 caracteres. Podés usar # $ @ Ñ ñ . * -</span>
        </div>

        <div className="lp-field">
          <label htmlFor="register-password-confirm">Repetí la contraseña</label>
          <input type="password" id="register-password-confirm" minLength={6} maxLength={20} name="register-password-confirm" autoComplete="new-password" required value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)}/>
        </div>

        <label className='lp-check' htmlFor="terms">
          <input type="checkbox" required name="terms" id="terms" onChange={e => e.target.setCustomValidity("")} onInvalid={e => e.target.setCustomValidity("Debes aceptar los términos y condiciones y las políticas de privacidad para registrarte.")}/>
          <span>Acepto los <a href="/terminos-y-condiciones" target="_blank" rel="noreferrer">Términos y condiciones</a> y las <a href="/politicas-de-privacidad" target="_blank" rel="noreferrer">Políticas de privacidad</a></span>
        </label>

        <button className="lp-btn lp-btn-primary" type="submit">Crear cuenta gratis</button>
      </form>

      <p className="lp-auth-switch">¿Ya tenés cuenta? <Link to="/login">Iniciá sesión</Link></p>

      <Toaster></Toaster>
    </AuthLayout>
  )
}

export default Register